import React from 'react';
import { Box } from '@mui/material';

import { COLOR_PANEL_BACKGROUND, COLOR_PANEL_BORDER } from '../constants/styleValues';

//the one reusable card surface used across the game screens (question box, leaderboard, lobby, ...)
const Panel = ({ children, sx = {}, ...rest }) => (
    <Box
        sx={{
            backgroundColor: COLOR_PANEL_BACKGROUND,
            border: `1px solid ${COLOR_PANEL_BORDER}`,
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
            ...sx
        }}
        {...rest}
    >
        {children}
    </Box>
);

export default Panel;
